import Botao from '../Botao/Botao';
import Modal from '../Modal/Modal';
import { BotaoContainer, ModalContainerDelete } from './styles';

interface updateModalProps {
  isModalOpen: boolean;
  onUpDateClick: any;
  onCloseModal: any;
}

const UpdateModal = (props: updateModalProps): any => {
  const { isModalOpen, onUpDateClick, onCloseModal } = props;

  return (
    <Modal
      isOpen={isModalOpen}
      width={420}
      onClose={() => {
        onCloseModal();
      }}
    >
      <>
        <ModalContainerDelete>
          <h1> Deseja atualizar os dados da proposta?</h1>
          <BotaoContainer>
            <Botao
              tipo="salvar"
              tamanho="medio"
              className="btn"
              disabled={false}
              onClick={() => {
                onUpDateClick();
                setTimeout(() => {
                  onCloseModal()
                },1000)
              }}
            >
              Atualizar
            </Botao>
            <Botao
              tamanho="medio"
              className="btn"
              onClick={() => {
                onCloseModal();
              }}
            >
              Cancelar
            </Botao>
          </BotaoContainer>
        </ModalContainerDelete>
      </>
    </Modal>
  );
};

export default UpdateModal;
